<script>
    import { onMount } from "svelte";
    import moment from 'moment'

  
    let arrivalDate = "";
    let lastnightDate = "";
    let arrivalDateSelected = false;
    let lastnightDateSelected = false;
    let selectedOption = "Y Warws";
    let status = "";
    let email = "";
    let tel = "";
    let info = "";
    let fname = "";
    let lname = "";
    let bookingstatus = "";
    const getcalendar = () => {};
  
    let isbookedday = null;
    let isbookedmonth = null;
    let isbookedyear = null;
  
    let bookings = [];
    let sortedbookings = [];
    let bookedingsent = false;
  
    //let endpoint = "https://bookings.acs-web.co.uk/all";
    let endpoint = "http://192.168.0.102:3049/all";
    const getBookingDates = async () => {
      status = "Getting booking dates for ";
      const response = await fetch(endpoint);
      bookings = await response.json();
      for (let booking of bookings) {
        const fromDate = new Date(booking.from);
        const toDate = new Date(booking.to);
  
        while (fromDate <= toDate) {
          let addeddate = new Date(fromDate.setDate(fromDate.getDate()));
          sortedbookings = [
            ...sortedbookings,
            { book_item: booking.book_item, bookingdate: addeddate },
          ];
          addeddate = new Date(fromDate.setDate(fromDate.getDate() + 1));
          //console.log(fromDate)
        }
      }
      status = "";
    };
  
    onMount(() => {
      getBookingDates();
    });
    //check if there is a booking date equal to the calendar date
    const isBooking = (date) => {
      // Loop through the sortedbookings array
  
      for (const booking of sortedbookings) {
        if (
          booking.bookingdate.toLocaleDateString("en-GB") ===
            date.toLocaleDateString("en-GB") &&
          booking.book_item == selectedOption
        ) {
          //console.table(sortedbookings)
          //console.log("==================date matched===================")
          //console.log("selected option :"+selectedOption)
          //console.log(booking.book_item)
          //console.log("calendar date:"+date)
          //console.log(booking.bookingdate)
          return true;
        }
      }
      return false;
    };
  
    //Make a new arrayof booking dates
  
    let date = new Date();
  
    const today = {
      dayNumber: date.getDate(),
      month: date.getMonth(),
      year: date.getFullYear(),
    };
  
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let monthIndex = date.getMonth();
    // const currentMonth = date.toLocaleString('en-US', { month: 'long' })
    $: month = monthNames[monthIndex];
  
    let year = date.getFullYear();
  
    $: firstDayIndex = new Date(year, monthIndex, 1).getDay();
    // const currentDay = date.getDate();
    $: numberOfDays = new Date(year, monthIndex + 1, 0).getDate();
  
    $: calendarCellsQty = firstDayIndex <= 4 ? 35 : 42;
  
    const goToNextMonth = () => {
      if (monthIndex >= 11) {
        year += 1;
        return (monthIndex = 0);
      }
      return (monthIndex += 1);
    };
  
    const goToPrevMonth = () => {
      if (monthIndex <= 0) {
        year -= 1;
        return (monthIndex = 11);
      }
      return (monthIndex -= 1);
    };
  
    const selectedOptionChanged = () => {
      sortedbookings = [];
      getBookingDates();
    };
  
    const sendBooking = async () => {
      if(fname === ""){
        status="Please enter your details"
      return
      }
      if (!bookedingsent) {
        try {
          const response = await fetch(
            //"https://bookings.acs-web.co.uk/bookingdata",
            "http://192.168.0.102:3049/bookingdata",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                fname: fname,
                lname: lname,
                info: info,
                option: selectedOption,
                arrivaldate: arrivalDate,
                lastnightdate: lastnightDate,
                email: email,
                tel: tel,
              }),
            }
          );
  
          if (response.ok) {
            console.log("Data sent successfully");
            bookingstatus =
              "Thank you for booking a request. We will confirm your booking as soon as possible";
            bookedingsent = true;
          } else {
            console.error("Failed to send data");
            bookingstatus ="Sorry, there was an error making your booking. Please try again or call us"
          }
        } catch (error) {
          console.error("Error sending data:", error);
        }
        console.log(
          fname +
            lname +
            email +
            selectedOption +
            arrivalDate +
            lastnightDate +
            info +
            tel
        );
      } else {
        bookingstatus = "You have already made your booking. Thank you";
      }
    };
  </script>
  
  <main>
    <p>Please enter your details below & select your accommodation</p>
    <div>
      <input type="text" placeholder="first name" bind:value={fname} />
      <input type="text" placeholder="last name" bind:value={lname} />
    </div>
    <div>
      <input type="tel" placeholder="telephone number" bind:value={tel} />
      <input type="email" placeholder="email address" bind:value={email} />
    </div>
    <div>
      <input
        type="text"
        name="arrivaldate"
        value={arrivalDate}
        placeholder="First night - select from calendar"
        readonly
      />
      <input
        type="text"
        name="lastlnight"
        value={lastnightDate}
        placeholder="Last night - select from calendar"
        readonly
      />
    </div>
    <textarea
      class='message'
      placeholder="Please include any requests or important details"
      bind:value={info}
    />
  
    {status}
  
    <div>
      <button class="bookbutton" on:click={sendBooking}>Book now</button>
    </div>
    <div>{bookingstatus}</div>
  
    <div class="month">
      <select on:change={selectedOptionChanged} bind:value={selectedOption}>
        <option value="Y Warws">Y Warws (sleeps 4)</option>
        <option value="Warws Bach">Warws Bach (sleeps 2)</option>
      </select>
      <ul>
        <li><button class="prev" on:click={goToPrevMonth}>&#10094;</button></li>
        <li><button class="next" on:click={goToNextMonth}>&#10095;</button></li>
        <li>
          showing {selectedOption}<br />
          {month}
          <span style="font-size:18px">{year}</span>
        </li>
      </ul>
      <span class="displaydate">{arrivalDate}</span>
      {#if arrivalDate != ""} to {/if}
      <span class="displaydate">{lastnightDate}</span>
      
    </div>
  
    <ul class="weekdays">
      <li>Su</li>
      <li>Mo</li>
      <li>Tu</li>
      <li>We</li>
      <li>Th</li>
      <li>Fr</li>
      <li>Sa</li>
    </ul>
  
    {#if sortedbookings.length}
      <ul class="days">
        {#each Array(calendarCellsQty) as _, i}
          {#if i < firstDayIndex || i >= numberOfDays + firstDayIndex}
            <li>&nbsp;</li>
          {:else}
            <li>
              <button 
            class='daybtn'
              on:click={() => {

                //took off +1
                date = new Date(year, monthIndex, i - firstDayIndex +1);
  
                if (arrivalDateSelected === false) {
                  arrivalDate = moment.utc(date).format('YYYY-MM-DD')
                  arrivalDateSelected = true;
                  lastnightDateSelected = false;
                } else if (lastnightDateSelected === false) {
                  lastnightDate = moment.utc(date).format('YYYY-MM-DD')
                  lastnightDateSelected = true;
                  arrivalDateSelected = false;
                }
              }}
              class:booked={isBooking(
                //took + 1 off as dates not displayed correctly 
                new Date(year, monthIndex, i - firstDayIndex +1)
              )}
              >
              <!---took + 1 off as dates not displayed correctly ---> 
              {i - firstDayIndex +1}
            
            </li>
          {/if}
        {/each}
      </ul>
    {/if}
  </main>
  
  
  <style>
    .daybtn{
      width:100%;
      min-height: 100%;
      cursor: pointer;
    }
    .daybtn:hover{
      background-color: #d6b686;
    }
    .displaydate {
      color: #f2480a;
    }
    main {
      display: flex;
      flex-direction: column;
      width: 60vw;
      justify-content: center;
      text-align: center;
      margin: auto;
    }
    ul {
      list-style-type: none;
    }
  
    /* Month header */
    .month {
      padding: 20px 25px;
      width: 90%;
      background: #d6b686;
      text-align: center;
      margin: auto;
    }
    .message{
      width: 90%;
      margin: auto;
      font-size: large;
    }
    /* Month list */
    .month ul {
      margin: 0;
      padding: 0;
    }
  
    .month ul li {
      color: white;
      font-size: 20px;
      text-transform: uppercase;
      letter-spacing: 3px;
    }
  
    /* Previous button inside month header */
    .month .prev {
      float: left;
      padding-top: 10px;
      cursor: pointer;
    }
  
    /* Next button */
    .month .next {
      float: right;
      padding-top: 10px;
      cursor: pointer;
    }
  
    /* Weekdays (Mon-Sun) */
    .weekdays {
      display: flex;
      flex-direction: row;
      margin: auto;
      padding: 10px 0 10px 0;
      background-color: #ddd;
      text-align: center;
      justify-content: center;
      width: 90%;
    }
  
    .weekdays li {
      display: inline;
      width: 13.85%;
      color: #000000;
      text-align: center;
    }
  
    /* Days (1-31) */
    .days {
      padding: 0px 0;
      background: #67aac9;
      color: thistle;
      width: 100%;
      text-align: center;
      justify-content: center;
    }
  
    .days li {
      list-style-type: none;
      display: inline-block;
      border: 1px solid rgba(0, 0, 0, 0.001);
      height: 70px;
      width: 12.5%;
      text-align: center;
      margin-bottom: 1px;
      font-size: 1.2rem;
      color: #000000;
      
    }
    .days li:hover {
      background-color: cadetblue;
    }
  
    /* Highlight the "current" day */
    
    .booked {
      background-color: #f2480a;
      padding: 0px;
      color: #ffffff;
      pointer-events: none;
    }
  
    
  
    select {
      border-radius: 5px;
      padding: 5px;
      margin: 5px;
      background-color: #d6b686;
      color: #ffffff;
      font-size: large;
    }
    input {
      border-radius: 5px;
      padding: 5px;
      margin-bottom: 5px;
      background-color: #d6b686;
      color: #ffffff;
      font-size: large;
      width: 40%;
    }
    textarea {
      border-radius: 5px;
      padding: 15px;
      margin: 15px;
      background-color: #d6b686;
      color: #ffffff;
      font-size: large;
      height: 120px;
    }
    .bookbutton {
      border-radius: 5px;
      margin: 5px;
      width: 90%;
      padding: 10px;
      font-size: larger;
      color: #d6b686;
    }
    .bookbutton:hover {
      color: #f9f8f6;
      background-color: #f24809;
      cursor: pointer;
    }
    @media screen and (max-width: 800px) {
      main {
        width: 100%;
      }
      .days li {
        height: 50px;
      }
      .month{
        width: 100%;
        padding: 0px;
      }
      .daybtn{
        font-size: large;
      }
    }
  </style>
  